const downloadFile$ = 'downloads/downloadFile$';
const setDownloadRequestSuccessful = 'downloads/setDownloadRequestSuccessful';
const setDownloadSubmitting = 'downloads/setDownloadSubmitting';

export default {
  downloadFile$,
  setDownloadRequestSuccessful,
  setDownloadSubmitting,
};
